module.exports = __webpack_public_path__ + "img/10手机.3ea8189c.png";